import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tab, Tabs, Tooltip } from "@mui/material";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { getVisibleMenuItems } from "./dsokCustomerDetailMenuConfig";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";

const DsokCustomerDetailMenu = () => {
  const { customerUrl } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const auth = useJumboAuth();
  const authUser = auth?.getAuthUser?.() || {};
  const userTyp = authUser?.type ?? authUser?.typ ?? 1;
  const customerType =
    authUser?.customer?.customerType ?? authUser?.customer?.customer_type;
  const effectiveTyp = customerType === 7 ? 7 : userTyp;

  const { hasEasyBuy, dsokSettings, customer } = useDsokCustomerDetail();

  const frontendType =
    customer?.frontendType ??
    dsokSettings?.customer?.frontendType ??
    dsokSettings?.frontendType ??
    null;
  const isEasyFood = String(frontendType || "").trim() === "easyFood";

  let items = getVisibleMenuItems(effectiveTyp);
  if (!hasEasyBuy || isEasyFood) {
    items = items.filter(
      (item) =>
        item.id !== "categories" && item.id !== "dynamic-components"
    );
  }
  const activeIndex = items.findIndex(
    (item) => item.pathBuilder(customerUrl) === pathname
  );
  const value = activeIndex >= 0 ? activeIndex : false;

  const handleChange = (_, newIndex) => {
    const item = items[newIndex];
    if (item?.enabled) {
      navigate(item.pathBuilder(customerUrl));
    }
  };

  if (items.length === 0) return null;

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        mb: 2,
        minHeight: 40,
        "& .MuiTabs-indicator": {
          backgroundColor: "primary.main",
        },
        "& .MuiTab-root": {
          textTransform: "none",
          minHeight: 40,
        },
      }}
    >
      {items.map((menuItem) => (
        <Tab
          key={menuItem.id}
          label={
            menuItem.enabled
              ? t(menuItem.labelKey)
              : (
                <Tooltip title={t("dsokCustomerDetail.menu.comingSoon")}>
                  <span>{t(menuItem.labelKey)}</span>
                </Tooltip>
              )
          }
          disabled={!menuItem.enabled}
          id={`dsok-customer-detail-tab-${menuItem.id}`}
          aria-controls={`dsok-customer-detail-tabpanel-${menuItem.id}`}
        />
      ))}
    </Tabs>
  );
};

export default DsokCustomerDetailMenu;
